import { Record } from 'immutable';

const AuthenticationData = Record({
  principalName: '',
  password: ''
});

export default AuthenticationData;